import { TaskListProvider } from '@app/providers';
import { PageProvider } from '@app/providers/PageProvider/PageProvider.main';
import { TechSupportModeProvider } from '@app/providers/TechSupportMode/TechSupportModeContext';

// LeadsProvider has been removed from the root: Leads owns the ordinary
// registry (search, filters, realtime, SearchId cleanup, mass actions), the
// LeadCard route reads the Leads bridge, and the only remaining `useLeads`
// consumers (old Leads pages / legacy Chat) are unrouted and deleted in
// Phase 11. Mounting it globally is no longer required.
export const RootProviders = () => (
  <TechSupportModeProvider>
    <TaskListProvider>
      <PageProvider />
    </TaskListProvider>
  </TechSupportModeProvider>
);
